(function () {
  'use strict';

  function pintrkTrack(event, data) {
    if (typeof window.pintrk === 'function') {
      window.pintrk('track', event, data);
    }
  }

  function getCountry() {
    return (window.perfenqPinterest && window.perfenqPinterest.catalogCountry) || 'US';
  }

  function getCurrency() {
    return (window.perfenqPinterest && window.perfenqPinterest.currency) || 'USD';
  }

  // Pinterest catalog product ID format: shopify_[COUNTRY]_[PRODUCT_ID]_[VARIANT_ID]
  function formatPinterestId(productId, variantId) {
    return 'shopify_' + getCountry() + '_' + productId + '_' + variantId;
  }

  // AddToCart: hooks into Shopify theme's internal pubsub (pubsub.js + constants.js are global)
  // subscribe() and PUB_SUB_EVENTS are defer-loaded before this script in document order.
  // trySubscribe retries in case of any race on slow connections.
  function initAddToCartTracking() {
    function trySubscribe() {
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        subscribe(PUB_SUB_EVENTS.cartUpdate, function (data) {
          if (data.source !== 'product-form') return;

          var cartData = data.cartData;
          var variantId = String(data.productVariantId);

          // /cart/add.js with sections param returns { items: [...], sections: {...} }
          var items = cartData && cartData.items ? cartData.items : [];
          var addedItem = items.find(function (item) {
            return String(item.variant_id) === variantId;
          });

          // Fallback: older format returns the line item directly at top level
          if (!addedItem && cartData && cartData.variant_id) {
            addedItem = cartData;
          }

          if (!addedItem) return;

          pintrkTrack('AddToCart', {
            content_ids: [formatPinterestId(addedItem.product_id, addedItem.variant_id)],
            content_name: addedItem.product_title || addedItem.title || '',
            content_category: addedItem.product_type || '',
            value: parseFloat((addedItem.price / 100).toFixed(2)),
            currency: getCurrency(),
            quantity: 1,
          });
        });
      } else {
        setTimeout(trySubscribe, 200);
      }
    }
    trySubscribe();
  }

  // InitiateCheckout: intercepts any checkout button/link click, then fetches live cart
  // for accurate value, currency, and content_ids before firing.
  function initCheckoutTracking() {
    document.addEventListener(
      'click',
      function (e) {
        var target = e.target;
        var isCheckout =
          target.matches('[name="checkout"]') ||
          target.matches('a[href*="/checkout"]') ||
          target.matches('button[data-checkout]') ||
          !!target.closest('[name="checkout"]') ||
          !!target.closest('a[href*="/checkout"]');

        if (!isCheckout) return;

        fetch('/cart.js')
          .then(function (r) {
            return r.json();
          })
          .then(function (cart) {
            var contentIds = cart.items.map(function (item) {
              return formatPinterestId(item.product_id, item.variant_id);
            });

            pintrkTrack('InitiateCheckout', {
              content_ids: contentIds,
              value: parseFloat((cart.total_price / 100).toFixed(2)),
              currency: getCurrency(),
              num_items: cart.item_count,
            });
          })
          .catch(function () {
            // Fire without data rather than miss the event entirely
            pintrkTrack('InitiateCheckout', {});
          });
      },
      true // capture phase so we catch it before any SPA navigation handler
    );
  }

  initAddToCartTracking();
  initCheckoutTracking();
})();
